import { PreviewRtcPeerConnectionFactory } from '../webrtc/preview-rtc-peer-connection-factory';
import { PreviewRtcGuestConnection } from './preview-rtc-guest-connection';
export class PreviewRtcGuestConnectionFactory extends PreviewRtcPeerConnectionFactory {
    constructor(iceServers, messageListener, role) {
        super(iceServers, role);
        this.messageListener = messageListener;
    }
    createConnection(signalingChannel, connection, clientId, peerId, peerScope) {
        return new PreviewRtcGuestConnection(signalingChannel, connection, peerScope, clientId, peerId, this.messageListener, this.role);
    }
}
//# sourceMappingURL=preview-rtc-guest-connection-factory.js.map